/* eslint no-console:0 */

import '@fortawesome/fontawesome-free/css/all';
import 'bootstrap/scss/bootstrap.scss';
import '../src/application.css';

import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';

import 'jquery-dropdown';
import '../src/label_dimensions';
import '../src/paper_sizes';

if (!window._rails_loaded) {
  require('@rails/ujs').start();
}
